var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAcute = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "acute_svg__a",
  width: 22,
  height: 22,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h22v22H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#acute_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.75 18.333q-3.07 0-5.202-2.131-2.13-2.13-2.131-5.202 0-3.048 2.131-5.19 2.13-2.144 5.202-2.143 3.048 0 5.19 2.142 2.144 2.143 2.143 5.19 0 3.072-2.142 5.203-2.143 2.13-5.19 2.131m0-1.833q2.291 0 3.896-1.604T19.25 11t-1.604-3.896Q16.04 5.5 13.75 5.5T9.854 7.104Q8.25 8.708 8.25 11t1.604 3.896T13.75 16.5m2.085-2.086 1.307-1.306-2.475-2.475v-3.3h-1.834v4.056zM1.833 8.25V6.417H5.5V8.25zm-.916 3.666v-1.833H5.5v1.833zm.916 3.667V13.75H5.5v1.833z"
}))));
export default SvgAcute;